/* eslint-disable angular/function-type */
;(() => {
  angular
    .module('app.ui.form.ctrls')
    .controller('EmailSubscriptionController', [
      'logger',
      'CandidateProfileApi',
      '$scope',
      '$location',
      // eslint-disable-next-line func-names
      function EmailSubscriptionController(
        logger,
        CandidateProfileApi,
        $scope,
        $location
      ) {
        let vm = this
        vm.succeeded = false
        vm.pauseFlag = false
        const url = $location.url()
        console.debug(`url is ${$location.url()}`)
        let start = url.indexOf('=') + 1
        let end = url.indexOf('-')
        // eslint-disable-next-line unicorn/prefer-string-slice
        let candidateId = url.substring(start, end)
        console.debug(`candidateId is ${candidateId}`)
        vm.emailTypeName = ''
        let emailTypeID = Number.parseInt(url.slice(Math.max(0, end + 1)), 10)
        console.debug('emailTypeID', emailTypeID)
        vm.emailType = ''

        if (emailTypeID === 1) {
          vm.emailType = 'Weekly'
          vm.emailTypeName = 'weekly_position_ping'
        } else if (emailTypeID === 2) {
          vm.emailType = 'Daily'
          vm.emailTypeName = 'daily_positions_ping'
        }

        console.debug('email type and email type name', {
          emailType: vm.emailType,
          emailTypeName: vm.emailTypeName,
        })

        vm.unsubscribe = true
        vm.succeeded = false

        vm.initializeEmailSubscription = async () => {
          console.debug('initializeEmailSubscription')
          const {
            data: emailSubscriptions,
          } = await CandidateProfileApi.getEmailSubscriptions(candidateId)
          const emailSubscribed = emailSubscriptions.find(
            ({emailId}) => vm.emailTypeName === emailId
          )
          if (url.includes('pause')) {
            console.warn('pause detected in url. checking if should pause')
            if (emailSubscribed && !emailSubscribed.paused) {
              vm.unsubscribe = true
              const date = new Date()
              const dateAfterThreeMonths = new Date(
                date.setMonth(date.getMonth() + 3)
              )
              vm.daysBetweenDates = Math.ceil(
                (dateAfterThreeMonths.getTime() - new Date().getTime()) /
                  (1000 * 60 * 60 * 24)
              )
            } else {
              console.debug('should not pause. email already paused')
              vm.unsubscribe = false
            }
          }

          if (url.includes('unsubscribe')) {
            console.warn(
              'unsubscribe detected in url. checking if should pause'
            )
            if (emailSubscribed && !emailSubscribed.stopped) {
              console.warn('should unsubscribe')
              vm.unsubscribe = true
            } else {
              console.debug('should not unsubscribe. email already stopped')
              vm.unsubscribe = false
            }
          }

          $scope.$applyAsync()
        }

        vm.doUnsubscribe = async () => {
          console.debug('attempting to unsubscribe')
          try {
            await CandidateProfileApi.unsubscribe(candidateId, vm.emailTypeName)
            logger.notify('success', 'Email Successfully Unsubscribed!')
            vm.succeeded = true
          } catch (error) {
            console.error(error)
            logger.notify('error', 'Could not Unsubscribe from email')
          }

          $scope.$applyAsync()
        }

        vm.doSubscribe = async () => {
          console.debug('attempting to resubscribe')
          try {
            await CandidateProfileApi.subscribe(candidateId, vm.emailTypeName)
            logger.notify('success', 'Email Successfully subscribed!')
            vm.succeeded = true
          } catch (error) {
            console.error(error)
            logger.notify('error', 'Could not Subscribe to email ')
          }

          $scope.$applyAsync()
        }

        vm.doUnpause = async () => {
          console.debug('attempting to unpause')
          try {
            await CandidateProfileApi.unpauseEmail(
              candidateId,
              vm.emailTypeName
            )
            vm.succeeded = true
            logger.notify('success', `Email Successfully Un Paused!`)
          } catch (error) {
            console.error(error)
            logger.notify('error', 'Could not Un Pause email ')
          }

          $scope.$applyAsync()
        }

        vm.doPause = async () => {
          console.debug('attempting to pause', vm.daysBetweenDates)
          try {
            await CandidateProfileApi.pauseEmail(
              candidateId,
              vm.emailTypeName,
              vm.daysBetweenDates
            )
            logger.notify('success', `Email Successfully Paused!`)
            vm.succeeded = true
          } catch (error) {
            console.error(error)
            logger.notify('error', 'Could not Pause email ')
          }

          $scope.$applyAsync()
        }

        vm.initializeEmailSubscription()
      },
    ])
})()



// WEBPACK FOOTER //
// ./scripts/form/email-subscriptions.ctrl.js